'use client'

import { Button } from '@/components/ui/common/Button'
import DashboardLayout from '@/views/dashboard/DashboardLayout'
import { Brain, ClipboardCheck, Database, FileText } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function ExpertsPage() {
  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="space-y-8">
          <div className=" ">
            
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              <div className="  border border-purple-200 bg-purple-50 p-4">
                <div className="mb-2 flex items-center">
                  <Brain className="mr-2 h-5 w-5 text-purple-600" />
                  <h3 className="font-medium text-gray-900">Testy neuropsychologiczne</h3>
                </div>
                <p className="mb-3 text-sm text-gray-600">
                  Specjalistyczne testy poznawcze
                </p>
                <Link to="/experts/neurophysicstests">
                  <Button className="w-full border-gray-200 bg-white border-1" size="sm" variant="outline">
                    Przeglądaj testy
                  </Button>
                </Link>
              </div>

              <div className="  border border-indigo-200 bg-indigo-50 p-4">
                <div className="mb-2 flex items-center">
                  <FileText className="mr-2 h-5 w-5 text-indigo-600" />
                  <h3 className="font-medium text-gray-900">Narzędzia diagnostyczne</h3>
                </div>
                <p className="mb-3 text-sm text-gray-600">
                  Kwestionariusze i skale oceny
                </p>
                <Link to="#">
                  <Button className="w-full border-gray-200 bg-white border-1" size="sm" variant="outline">
                    Zobacz narzędzia
                  </Button>
                </Link>
              </div>

              <div className="  border border-green-200 bg-green-50 p-4">
                <div className="mb-2 flex items-center">
                  <Database className="mr-2 h-5 w-5 text-green-600" />
                  <h3 className="font-medium text-gray-900">Baza przypadków</h3>
                </div>
                <p className="mb-3 text-sm text-gray-600">Studia przypadków i analizy</p>
                <Link to="#">
                  <Button className="w-full border-gray-200 bg-white border-1" size="sm" variant="outline">
                    Przeglądaj przypadki
                  </Button>
                </Link>
              </div>

              <div className="  border border-orange-200 bg-orange-50 p-4">
                <div className="mb-2 flex items-center">
                  <ClipboardCheck className="mr-2 h-5 w-5 text-orange-600" />
                  <h3 className="font-medium text-gray-900">Protokoły badań</h3>
                </div>
                <p className="mb-3 text-sm text-gray-600">Standardowe protokoły oceny</p>
                <Link to="#">
                  <Button className="w-full border-gray-200 bg-white border-1" size="sm" variant="outline">
                    Zobacz protokoły
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
